import router from "@/router";
import { ROUTE_NAMES } from "@/router/types";

export function goToError(uuid?: string): void {
    const query = uuid ? { uuid } : undefined;
    router.push({ name: ROUTE_NAMES.Error, query }).catch(() => {});
}

export enum QuoteRecallErrorMessages {
    NAME = "Proposal not found (Error: 1)",
    DOB = "Proposal not found (Error: 2)",
    REFERENCE = "Proposal not found (Error: 3)",
    ACCEPTED = "Proposal not found (Error: 4)",
    EXPIRED = "Proposal not found (Error: 5)",
    EXPIRED_OFFLINE = "Proposal not found (Error: 6)",
    NOT_QUOTED = "Proposal not found (Error: 7)"
}

export enum QuoteRecallErrorFields {
    NAME = "name",
    DOB = "dob",
    REFERENCE = "reference",
    ACCEPTED = "accepted",
    EXPIRED = "expired",
    EXPIRED_OFFLINE = "expired_offline",
    NOT_QUOTED = "not_quoted",
    RESET = "reset"
}
